import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as InsuranceCalculationActions from 'store/insuranceCalculation';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

export const usePurchaseMethodPresenter = () => {
  const dispatch = useDispatch();

  const errors = useSelector(CarInstanceSelectors.selectErrors);
  const isInCredit = useSelector(InsuranceCalculationSelectors.selectIsInCredit);
  const { [CarInstanceConstants.VALUE_FIELDS.CAR_ISSUE_DATE]: carIssueDate } = useSelector(
    CarInstanceSelectors.selectValues
  );

  const { disabled: pageRestrict } = useDisabledFields();

  const onChangeIsInCredit = useCallback((isInCredit) => {
    dispatch(InsuranceCalculationActions.insuranceSetIsInCredit(isInCredit));
    dispatch(InsuranceCalculationActions.insuranceSetSelectedBank(undefined));
    dispatch(
      InsuranceCalculationActions.insuranceSetErrors({
        [InsuranceCalculationConstants.FIELDS.SELECTED_BANK]: { id: '' },
      })
    );
  }, []);
  const onClickCreditButton = useCallback(() => {
    onChangeIsInCredit(true);
  }, [onChangeIsInCredit]);
  const onClickCashButton = useCallback(() => {
    onChangeIsInCredit(false);
  }, [onChangeIsInCredit]);
  const onChange = useCallback(({ key, value }) => {
    dispatch(CarInstanceActions.setCarInstance({ [key]: value }));
    dispatch(CarInstanceActions.updateErrors({ [key]: '' }));
  }, []);
  const onChangeInput = useCallback(
    (event) => {
      const [[key, value]] = Object.entries(event);

      onChange({ key, value });
    },
    [onChange]
  );
  const onChangeSelect = useCallback(
    (option, key) => {
      const { id: value } = option ?? {};

      onChange({ key, value });
    },
    [onChange]
  );

  return {
    carIssueDate,
    disabled: pageRestrict,
    errors,
    isInCredit,
    onChangeInput,
    onChangeSelect,
    onClickCashButton,
    onClickCreditButton,
  };
};
